import { render, staticRenderFns } from "./JobApplicationHeader.vue?vue&type=template&id=a0537a6c&scoped=true&"
import script from "./JobApplicationHeader.vue?vue&type=script&lang=js&"
export * from "./JobApplicationHeader.vue?vue&type=script&lang=js&"
import style0 from "./JobApplicationHeader.vue?vue&type=style&index=0&id=a0537a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0537a6c",
  null
  
)

component.options.__file = "JobApplicationHeader.vue"
export default component.exports